import { useKeycloak } from '@react-keycloak/web'
import { useState, useCallback, useEffect } from 'react'

const CONSENT_KEY = 'user_consent'

function isUserConsentAccepted(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'true'
  } catch {
    return false
  }
}

export function useConsentGate() {
  const [requiresConsent, setRequiresConsent] = useState(true)
  const { keycloak, initialized } = useKeycloak()

  const isConsentRequired = useCallback(() => {
    const accepted = isUserConsentAccepted()
    setRequiresConsent(!accepted)
  }, [])

  const accept = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'true')
    isConsentRequired()
  }, [isConsentRequired])

  useEffect(() => {
    isConsentRequired()
  }, [isConsentRequired])

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      localStorage.setItem(CONSENT_KEY, 'false')
    }
  }, [keycloak.authenticated, initialized])

  return { isConsentRequired, requiresConsent, accept }
}
